<template>
  <div class="intro">
    <div v-if="isLoading" class="loading-task">
      <half-circle-spinner
        :animation-duration="1000"
        :size="60"
        color="#52b700"
      />
    </div>
    <div class="task-container">
      <Memento />
      <div v-if="!levelend">
        <div class="row d-flex justify-content-between">
          <div v-if="show" class="col-sm-6 d-flex mt-5 p-3">
            <div v-for="(i, index) in results" :key="index">
              <b-icon
                :icon="ico_n[i * i]"
                :class="{
                  'bg-green': true,
                  'bg-red': i === -1,
                }"
              ></b-icon>
            </div>
          </div>

          <div class="col-md-4 text-center d-flex">
            <div class="card w-50 ml-0">
              <div class="card-header l"><span>НИЙТ ОНОО</span></div>
              <div class="card-body l">
                <div>{{ levelresult.score }}</div>
              </div>
            </div>
            <div class="card w-50 ml">
              <div class="card-header r"><span>ЦАГ</span></div>
              <div class="card-body r">
                <start-time class="mt-3" />
              </div>
            </div>
          </div>
        </div>
        <div v-if="!isLoading">
          <div class="content task">
            <div class="col-md-11 d-flex">
              <i class="far fa-question-circle fn"></i>
              <div class="mr-1">{{ taskNumber }}.</div>
              <div class="task-text" v-html="jsonData.question"></div>
            </div>
            <div class="col-md-1 task-score">{{ jsonData.point }} оноo</div>
          </div>
          <h4 v-if="solution">Зөв хариулт: {{ correct.text }}</h4>

          <div class="content choice">
            <i class="fas fa-dice-five fn"></i>
            <div v-for="(ans, idx) in answers" :key="idx">
              <div
                @click="selectAnswer(ans)"
                v-bind:class="{
                  'choice-body': true,
                  selected: ans.isSelected,
                }"
              >
                <div class="choice-letter">{{ ans.value }}</div>
                <div class="choice-value" v-html="ans.text"></div>
              </div>
            </div>
          </div>

          <button v-if="!solution" class="btn btn-success" @click="check">
            хариу илгээх
          </button>

          <div v-if="solution">
            <h4 v-if="renderExpect">Бодолт</h4>
            <b-collapse
              class="content ans pl-5"
              id="collapse-4"
              v-model="renderExpect"
            >
              <div v-if="renderExpect">
                <i class="far fa-check-circle fn"></i>
                <div v-html="explanation.text"></div>
              </div>
            </b-collapse>

            <div class="d-flex justify-content-between">
              <button
                v-if="!renderExpect"
                :aria-expanded="renderExpect ? 'true' : 'false'"
                class="btn btn-success"
                @click="toggle"
              >
                Бодолт харах
              </button>
              <button
                v-if="renderExpect"
                :aria-expanded="renderExpect ? 'true' : 'false'"
                class="btn btn-success"
                @click="toggle"
              >
                Бодолт хаах
              </button>
              <button
                class="btn btn-success"
                v-if="taskNumber < 5"
                @click="shift"
              >
                Дараагийн бодлого
              </button>
              <button
                class="btn btn-success"
                @click="getResultLevel"
                v-if="taskNumber > 4"
              >
                Дуусгах
              </button>
            </div>
          </div>
        </div>
      </div>
      <level-completed
        :levelresult="levelresult"
        v-if="levelend"
      ></level-completed>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import swal from "sweetalert";
import OwnerService from "../api-services/owner.service.js";
import startTime from "../components/startTime.vue";
import Memento from "../components/Memento.vue";
import LevelCompleted from "../components/LevelCompleted.vue";
//import PacketCompleted from "../components/PacketCompleted";
import { HalfCircleSpinner } from "epic-spinners";

export default {
  data() {
    return {
      angiId: -1,
      bagtsId: -1,
      levelId: -1,
      ico_n: ["star", "star-fill"],
      jsonData: {},
      answers: [],
      categoryId: 0,
      show: true,
      renderExpect: false,
      results: [0, 0, 0, 0, 0],
      checked: true, // шалгуулсан эсэх
      taskNumber: 1, // Бодлогын дугаар
      levelend: false,
      solution: false,
      diselect: false,
      totalPoint: 0,
      correct: { text: "" },
      explanation: { text: "" },
      isLoading: true,

      levelresult: {
        score: 0,
        percent: 0,
        point: 0,
        duration: 0,
        tryCounter: 0
      },
    };
  },
  components: {
    Memento,
    startTime,
    LevelCompleted,
    //PacketCompleted,
    HalfCircleSpinner,
  },
  methods: {
    async check() {
      if (!this.checked) {
        let aid = "";
        this.answers.forEach((ans) => {
          if (ans.isSelected) {
            aid = ans.value;
          }
        });
        try {
          const that = this;
          const resp = await OwnerService.checkQuestion({
            angi: this.angiId,
            bagts: this.bagtsId,
            qid: that.jsonData.id,
            aid: aid,
          });
          let isCorrect = resp.data == "success";
          if (isCorrect) {
            that.isLoading = false;
            that.levelresult.score =
              that.levelresult.score + that.jsonData.point;
            that.results[that.taskNumber - 1] = 1;
            swal("Баяр хүргэе", "Зөв хариуллаа", "success", {
              closeOnClickOutside: false,
              className: "red-bg",
              buttons: {
                catch0: {
                  visible: that.taskNumber < 5,
                  text: "Үргэлжлүүлэх",
                  value: "catch0",
                },
                catch1: {
                  visible: that.taskNumber > 4,
                  text: "Дуусгах",
                  value: "catch1",
                },
              },
            }).then((value) => {
              switch (value) {
                case "catch0":
                  that.shift();
                  break;
                case "catch1":
                  that.getResultLevel();
                  break;
                default:
              }
            });
          } else {
            that.show = false;
            that.results[that.taskNumber - 1] = -1;
            that.show = true;
            swal("Буруу хариулт", "", "error", {
              closeOnClickOutside: false,
              buttons: {
                catch0: {
                  text: "Хариу харах",
                  value: "catch0",
                },
                catch1: {
                  text: "Бодолт харах",
                  value: "catch1",
                },
                catch2: {
                  text: "Дахин оролдох",
                  value: "catch2",
                },
                catch3: {
                  visible: that.taskNumber < 5,
                  text: "Дараагийн бодлого",
                  value: "catch3",
                },
                catch4: {
                  visible: that.taskNumber > 4,
                  text: "Дуусгах",
                  value: "catch4",
                },
              },
            }).then((value) => {
              switch (value) {
                case "catch0":
                  that.renderAnswer();
                  break;
                case "catch1":
                  that.renderExpec();
                  break;
                case "catch2":
                  that.try();
                  break;
                case "catch3":
                  that.shift();
                  break;
                case "catch4":
                  that.getResultLevel();
                  break;
                default:
                  that.try();
              }
            });
          }
        } catch (ex) {
          console.log(ex);
        }
      }
    },

    shift: function () {
      this.solution = false;
      this.renderExpect = false;
      this.diselect = false;
      this.taskNumber = this.taskNumber + 1;
      this.loadQuestion();
      this.checked = true;
      this.totalPoint = this.totalPoint + this.jsonData.point;
    },

    try: function () {
      this.levelresult.tryCounter++;
      this.checked = false;
    },

    selectAnswer: function (ans) {
      if (!this.diselect) {
        this.answers.forEach((element) => {
          element.isSelected = false;
        });
        ans.isSelected = true;
        Vue.set(this.answers, this.answers.indexOf(ans), ans);
      }

      this.checked = false;
    },

    selectAnswers: function (idx) {
      this.answers.forEach((element) => {
        element.isSelected = false;
      });
      this.answers[idx].isSelected = true;
    },

    async renderAnswer() {
      this.diselect = true;
      try {
        const that = this;
        const resp = await OwnerService.getAnswer({
          angi: this.angiId,
          bagts: this.bagtsId,
          level: this.levelId,
          qid: that.jsonData.id,
        });
        that.solution = true;
        that.correct.text = resp.data;
        if (that.correct.text === "A") {
          that.selectAnswers(0);
        } else if (that.correct.text === "B") {
          that.selectAnswers(1);
        } else if (that.correct.text === "C") {
          that.selectAnswers(2);
        } else if (that.correct.text === "D") {
          that.selectAnswers(3);
        } else if (that.correct.text === "E") {
          that.selectAnswers(4);
        }
      } catch (ex) {
        console.log(ex);
      }
    },

    async renderExpec() {
      if (!this.renderExpect) {
        this.renderAnswer();
      }
      try {
        const that = this;
        const resp = await OwnerService.getExpect({
          angi: this.angiId,
          bagts: this.bagtsId,
          level: this.levelId,
          qid: that.jsonData.id,
        });
        that.explanation.text = resp.data;
        that.solution = true;
        that.renderExpect = true;
        window.scrollTo(0, 0);
        that.$nextTick(() => {
          setTimeout(() => {
            if (window.MathJax) {
              window.MathJax.typeset();
            }
          }, 10);
        });
      } catch (ex) {
        console.log(ex);
      }
    },

    toggle: function () {
      if (!this.renderExpect) {
        this.renderExpec();
      }
      this.renderExpect = !this.renderExpect;
    },

    getResultLevel: function () {
      this.levelend = true;
      this.levelresult.isCompleted = true;
      this.totalPoint = this.totalPoint + this.jsonData.point;

      this.levelresult.percent = Math.ceil(
        (this.levelresult.score / this.totalPoint) * 100
      );

      var s_new = new Date();
      var levelEndTime = s_new.getTime(s_new);

      this.levelresult.duration = levelEndTime - localStorage.getItem("start");
    },

    async loadQuestion() {
      this.isLoading = true;
      try {
        const that = this;
        const resp = await OwnerService.getQuestion({
          angi: this.angiId,
          bagts: this.bagtsId,
          level: this.levelId,
          qid: that.taskNumber,
        });
        that.isLoading = false;
        that.answers[0] = {
          text: resp.data.a_one,
          value: "A",
          isSelected: false,
        };
        that.answers[1] = {
          text: resp.data.a_two,
          value: "B",
          isSelected: false,
        };
        that.answers[2] = {
          text: resp.data.a_three,
          value: "C",
          isSelected: false,
        };
        that.answers[3] = {
          text: resp.data.a_four,
          value: "D",
          isSelected: false,
        };
        that.answers[4] = {
          text: resp.data.a_five,
          value: "E",
          isSelected: false,
        };
        that.jsonData = resp.data;
        window.scrollTo(0, 0);
        that.$nextTick(() => {
          setTimeout(() => {
            if (window.MathJax) {
              window.MathJax.typeset();
            }
          }, 10);
        });
      } catch (ex) {
        console.log(ex);
      }
    },
  },
  async mounted() {
    if (this.$route.params.lid !== undefined) {
      localStorage.setItem("level", this.$route.params.lid);
    } else {
      this.$route.push({ path: "/" });
    }

    this.categoryId = localStorage.getItem("category");
    this.angiId = localStorage.getItem("angi");
    this.bagtsId = localStorage.getItem("bagts");
    this.levelId = localStorage.getItem("level");

    await this.loadQuestion();
  },
  destroyed() {
    localStorage.removeItem("start");
  },
};
</script>

<style lang="postcss" scoped>
.intro {
  position: relative;
  min-height: 90vh;
}
.task-container {
  max-width: 1200px;
  margin: 0 auto 0 auto;
  padding: 0px 0px 50px 0px;
}
/*Цаг болон од*/
.bg-green {
  color: #52b700;
  font-size: 2.8em;
}
.bg-red {
  color: red;
}
.card {
  border: none;
  max-width: 196px;
  max-height: 122px;
  margin-bottom: 30px;
}
.card.w-50.ml-0 {
  border-bottom-left-radius: 1.25em;
  border-top-left-radius: 1.8em;
}
.card.w-50.ml {
  border-bottom-right-radius: 1.25em;
  border-top-right-radius: 1.8em;
}
.card-header {
  font-size: 1.25em;
  color: #fff;
  font-weight: 540;
  max-height: 43px;
  display: flex;
  align-items: center;
}
.card-header span {
  width: 100%;
}
.card-header.l {
  background-color: #69b644;
  border-top-left-radius: 1.25em;
  border-top-right-radius: 0;
}
.card-header.r {
  background-color: #26a3db;
  border-top-right-radius: 1.25em;
  border-top-left-radius: 0;
}
.card-body {
  color: #000000;
  font-size: 1.875em;
  display: flex;
  align-items: center;
  padding: 0;
  border: 2px solid #f3f3f3;
}
.card-body div {
  width: 100%;
}
.card-body .t-label {
  font-size: 65%;
  color: #6d6d6d;
}
.card-body.r {
  border-bottom-right-radius: 0.6em;
}
.card-body.l {
  border-bottom-left-radius: 0.6em;
}

/*Task css*/
.content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  background-color: #fff;
  padding: 20px;
  font-family: "Times New Roman";
  border-radius: 1.25em;
  position: relative;
}
.task {
  font-size: 1.4em;
  margin-bottom: 20px;
}
.ans {
  font-size: 1.4em;
}
.choice-content-solution {
  display: flex;
  flex-wrap: wrap;
}
.choice-body-solution {
  margin-top: 20px;
  display: flex;
  border-radius: 1.25em;
  background-color: #dfe6e9;
}
.choice-body {
  cursor: pointer;
  display: flex;
  padding: 0.2em;
  border-radius: 1.25em;
  background-color: #dfe6e9;
  min-width: 155px;
  min-height: 62px;
  margin: 20px;
}
.choice-body.selected {
  background-color: #52b700;
}

.task-text-order {
  font-size: 1.55em;
  font-family: roboto;
  padding-right: 8px;
}
.choice-letter {
  padding: 0 14px;
  text-align: center;
  cursor: pointer;
  font-size: 2em;
  color: #000000;
}
.choice-value {
  min-width: 102px;
  max-width: 400px;
  overflow-wrap: break-word;
  text-align: center;
  background-color: #fff;
  border-bottom-right-radius: 1.25em;
  border-top-right-radius: 1.25em;
  height: auto;
  color: #000000;
}
.choice-value >>> p {
  margin: 0;
  font-family: "Times New Roman";
  font-size: 2em;
}
.choice-value >>> img {
  border-bottom-right-radius: 15px;
  border-top-right-radius: 15px;
  padding: 3px;
}
.task-score {
  color: #2ecc71;
}
.btn {
  min-width: 135px;
  min-height: 32.98px;
  border-radius: 12px;
  font-size: 1.25em;
  margin-top: 20px;
}
h4 {
  margin-top: 20px;
  font-size: 1.4em;
}
.fn {
  background-color: #fff;
  position: absolute;
  border: 1px solid #fff;
  border-bottom-left-radius: 45px;
  border-top-left-radius: 45px;
  top: 50%;
  transform: translate(-50%, -50%);
}
.fa-question-circle {
  color: #52b700;
  font-size: 1.5em;
  padding: 10px;
  left: -1.5%;
  z-index: 1;
}

.fa-dice-five {
  color: #f9850c;
  font-size: 2em;
  padding: 10px 12px 10px 12px;
  left: -1.5%;
}
.fa-check-circle {
  color: #52b700;
  font-size: 1.5em;
  padding: 10px;
  left: -1.5%;
}
.loading-task {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
